export default "__VITE_PUBLIC_ASSET__c5a91574__"